import React, { Suspense, lazy } from 'react';
import { Hero } from '../components/Hero';
// Lazy load ALL below-fold and non-critical components
const ProductBreakdown = lazy(() => import('../components/ProductBreakdown').then(m => ({
  default: m.ProductBreakdown
})));
const Benefits = lazy(() => import('../components/Benefits').then(m => ({
  default: m.Benefits
})));
const Testimonials = lazy(() => import('../components/Testimonials').then(m => ({
  default: m.Testimonials
})));
const CallToAction = lazy(() => import('../components/CallToAction').then(m => ({
  default: m.CallToAction
})));
const CheckoutSection = lazy(() => import('../components/CheckoutSection').then(m => ({
  default: m.CheckoutSection
})));
const PurchasePopup = lazy(() => import('../components/PurchasePopup').then(m => ({
  default: m.PurchasePopup
})));
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-295">
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-200/50 header-fixed" role="banner" data-id="element-296">
        <div className="container mx-auto px-4 h-14 flex items-center justify-between" data-id="element-297">
          <a href="#" className="font-serif font-bold text-base text-pink-600 flex items-center gap-1.5" aria-label="MegaPack Danza Lista - Inicio" data-id="element-298">
            <span className="text-lg" aria-hidden="true" data-id="element-299">
              🩰
            </span>{' '}
            MegaPack Danza Lista
          </a>
          <nav className="hidden md:flex items-center gap-6 text-sm font-medium text-gray-600" aria-label="Navegación principal" data-id="element-300">
            <a href="#que-incluye" className="hover:text-pink-600 transition-colors" data-id="element-301">
              Qué Incluye
            </a>
            <a href="#beneficios" className="hover:text-pink-600 transition-colors" data-id="element-302">
              Beneficios
            </a>
            <a href="#testimonios" className="hover:text-pink-600 transition-colors" data-id="element-303">
              Testimonios
            </a>
            <a href="#comprar" className="bg-pink-600 text-white px-3.5 py-1.5 rounded-full hover:bg-pink-700 transition-colors text-xs font-bold uppercase tracking-wide" data-id="element-304">
              Comprar
            </a>
          </nav>
        </div>
      </header>

      <main data-id="element-305">
        <Hero data-id="element-306" />
        <Suspense fallback={null} data-id="element-307">
          <div className="below-fold-section" data-id="element-308">
            <ProductBreakdown data-id="element-309" />
          </div>
          <div id="beneficios" className="below-fold-section" data-id="element-310">
            <Benefits data-id="element-311" />
          </div>
          <div className="below-fold-section" data-id="element-312">
            <CheckoutSection data-id="element-313" />
          </div>
          <div id="testimonios" className="below-fold-section" data-id="element-314">
            <Testimonials data-id="element-315" />
          </div>
          <div className="below-fold-section" data-id="element-316">
            <CallToAction data-id="element-317" />
          </div>
        </Suspense>
      </main>

      <footer className="bg-gray-900 text-gray-300 py-12 border-t border-gray-800" role="contentinfo" data-id="element-318">
        <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-319">
          <div className="text-center md:text-left" data-id="element-320">
            <h2 className="text-white font-serif font-bold text-lg mb-2" data-id="element-321">
              🩰 MegaPack Danza Lista
            </h2>
            <p className="text-sm" data-id="element-322">
              Recursos educativos para docentes apasionados.
            </p>
          </div>
          <div className="text-sm text-center md:text-right" data-id="element-323">
            <p data-id="element-324">
              &copy; {new Date().getFullYear()} Todos los derechos reservados.
            </p>
            <p className="mt-1" data-id="element-325">Hecho con ❤️ para la comunidad de la danza.</p>
          </div>
        </div>
      </footer>
      <Suspense fallback={null} data-id="element-326">
        <PurchasePopup data-id="element-327" />
      </Suspense>
    </div>;
}